import { styled } from "../../styles";

export const Div = styled('div', {
  width: '100%',
})